var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-timepicker",
      class: _vm.sizeCss,
      style: { width: _vm.timePickerWidth },
    },
    [
      _c(
        "div",
        {
          staticClass: "v-timepicker__label input-text",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-focus": _vm.showTimePanel,
          },
          attrs: { name: _vm.name, "data-name": _vm._name },
          on: { click: _vm.showPanel },
        },
        [
          _c(
            "span",
            {
              class: { "placeholder-text": _vm.placeholder && !_vm.startTime },
            },
            [_vm._v(" " + _vm._s(_vm.startTime || _vm.placeholder) + " ")]
          ),
          _vm.isRange
            ? [
                _c("span", { staticClass: "v-timepicker__splitter" }, [
                  _vm._v("-"),
                ]),
                _c(
                  "span",
                  {
                    class: {
                      "placeholder-text": _vm.endPlaceholder && !_vm.endTime,
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.endTime || _vm.endPlaceholder) + " "
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("span", {
        staticClass: "v-timepicker__icon",
        class: [
          _vm.hasClear ? "v-icon-close-plane" : "v-icon-time",
          { "v-timepicker__icon--disabled": _vm.isDisabled },
        ],
        on: {
          mouseover: _vm.handlerMouseover,
          mouseout: function ($event) {
            _vm.isMouseover = false
          },
          click: _vm.clickIcon,
        },
      }),
      _c(
        "create-to-body",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.hide,
              expression: "hide",
            },
          ],
          class: _vm.sizeCss,
          attrs: {
            "data-name": _vm._name,
            show: _vm.showTimePanel,
            width: _vm.timePickerWidth,
            scale: _vm.isRange ? 2 : 1,
          },
        },
        [
          _vm.isRange
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "v-timepicker__title", attrs: { span: 12 } },
                    [_vm._v(_vm._s(_vm._("Start time")))]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "v-timepicker__title", attrs: { span: 12 } },
                    [_vm._v(_vm._s(_vm._("End time")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "v-timepicker__wrapper",
                  attrs: { span: _vm.isRange ? 12 : 24 },
                },
                [
                  _c("time-panel", {
                    attrs: {
                      format: _vm.format,
                      minuteInterval: _vm.minuteInterval,
                      secondInterval: _vm.secondInterval,
                      time: _vm.startTime,
                      min: _vm.min,
                      max: _vm.max,
                    },
                    on: { change: _vm.changeTime },
                  }),
                ],
                1
              ),
              _vm.isRange
                ? _c(
                    "v-col",
                    {
                      staticClass: "v-timepicker__wrapper",
                      attrs: { span: 12 },
                    },
                    [
                      _c("time-panel", {
                        attrs: {
                          format: _vm.format,
                          minuteInterval: _vm.minuteInterval,
                          secondInterval: _vm.secondInterval,
                          time: _vm.endTime,
                          min: _vm.min,
                          max: _vm.max,
                        },
                        on: { change: _vm.changeEndTime },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }